const { getProperty } = require('../PropertyGetter');

// Due to multiple sales, grabbing lowest price.
function getLowestTieredPrice(selectedPrice) {
  const tieredPrice = getProperty(selectedPrice, 'price.tieredPrice', []);
  return getProperty(tieredPrice, `[${tieredPrice.length - 1}].values`, {});
}

// Grabbing price and building for Klarna
function buildKlarnaPrice({ selectedFinalPrice = {}, selectedPrice = {} }) {
  const priceValue = selectedFinalPrice.values || getLowestTieredPrice(selectedPrice);
  const price = getProperty(priceValue, '[0].value', 0);
  return Math.floor(price * 100) || 0;
}

// Main exported method for Klarna data
const getKlarnaData = (actualPrice, additionalData) => {
  if (!getProperty(additionalData, 'featureEligible.klarna')) return {};

  const klarnaPrice = getProperty(additionalData, 'uiKillSwitches.isPDPEnhancementLEnabled') ?
    Math.floor(actualPrice.value * 100) || 0 :
    buildKlarnaPrice(actualPrice);

  // Flags that can be accessed in klarna for multiple display scenarios
  return {
    isWithinRange: klarnaPrice >= 1000 && klarnaPrice <= 100000,
    klarnaPrice,
  };
};

module.exports = {
  getKlarnaData,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/Klarna.js